module.exports = __webpack_public_path__ + "static/media/image-7.05d2e080.avif";